export class InventoryFilter {
  constructor(public searchTerm: string, public searchCriteria: SearchCriteria) {}
}

interface SearchCriteria {
  display: string;
  id: string;
}
